import { useEffect, useState } from 'react';

/** Açık modal sayısını takip eder; yüzen butonları gizlemek için kullanılır. */
let openCount = 0;
const subscribers = new Set();

const notify = () => subscribers.forEach((fn) => fn(openCount));

export const useLockFloatingButtons = () => {
  useEffect(() => {
    openCount += 1;
    notify();
    return () => {
      openCount = Math.max(0, openCount - 1);
      notify();
    };
  }, []);
};

export const useAnyModalOpen = () => {
  const [count, setCount] = useState(openCount);
  useEffect(() => {
    subscribers.add(setCount);
    return () => subscribers.delete(setCount);
  }, []);
  return count > 0;
};
